var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.76 42.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pdf-icon-red{fill:#cc4a4c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payroll_Concept",
    "data-name": "Payroll Concept"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pdf-icon-red",
    d: "M6.12,26.24H4.89v1.62H6.12a1.07,1.07,0,0,0,.71-.2.76.76,0,0,0,.23-.61C7.06,26.51,6.75,26.24,6.12,26.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdf-icon-red",
    d: "M12.07,26.32h-.84v3.83h.84a2,2,0,0,0,1.45-.47A2,2,0,0,0,14,28.23a1.92,1.92,0,0,0-.48-1.44A2,2,0,0,0,12.07,26.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdf-icon-red",
    d: "M21.14,23.05H2.45A1.65,1.65,0,0,0,.81,24.69v7.14a1.65,1.65,0,0,0,1.64,1.64H21.14a1.65,1.65,0,0,0,1.64-1.64V24.69A1.65,1.65,0,0,0,21.14,23.05ZM8.06,28.59a2.45,2.45,0,0,1-1.7.56H4.89v1.59a.84.84,0,0,1-.24.63A.87.87,0,0,1,4,31.6a.87.87,0,0,1-.63-.23.87.87,0,0,1-.23-.63v-5a.8.8,0,0,1,.21-.59.78.78,0,0,1,.59-.2h2.4a2.42,2.42,0,0,1,1.7.55,2.27,2.27,0,0,1,0,3.1ZM15.3,30a2.84,2.84,0,0,1-1.21,1.14,4.26,4.26,0,0,1-1.9.39H10.3a.8.8,0,0,1-.59-.21.77.77,0,0,1-.2-.59v-5a.7.7,0,0,1,.79-.79h1.89a4.22,4.22,0,0,1,1.89.39,2.92,2.92,0,0,1,1.22,1.14,3.53,3.53,0,0,1,.42,1.76A3.58,3.58,0,0,1,15.3,30Zm5.2-2.51a1,1,0,0,1,.62.17.66.66,0,0,1,.2.52.6.6,0,0,1-.2.5,1,1,0,0,1-.62.16H18.44v1.89a.83.83,0,0,1-.23.63.92.92,0,0,1-1.23,0,.85.85,0,0,1-.23-.62v-5a.84.84,0,0,1,.2-.59.8.8,0,0,1,.59-.2h3.15a1,1,0,0,1,.62.16.64.64,0,0,1,.2.52.6.6,0,0,1-.2.5,1,1,0,0,1-.62.16H18.44V27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdf-icon-red",
    d: "M36.37,13V38A3.07,3.07,0,0,1,33.3,41.1l-25-.18a3.07,3.07,0,0,1-3.06-3.07V35H6.77v2.89a1.57,1.57,0,0,0,1.57,1.58l25,.19A1.58,1.58,0,0,0,34.88,38V14.48h-8a3.35,3.35,0,0,1-3.35-3.35v-8L8.32,2.94A1.56,1.56,0,0,0,6.77,4.5V21.56H5.28V4.5a3.06,3.06,0,0,1,3.05-3l16.32.19H25ZM34.2,13,25,3.81v7.32A1.86,1.86,0,0,0,26.87,13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIconRed);
export default __webpack_public_path__ + "static/media/pdf_icon_red.9b827e092686de173a880457311cadf8.svg";
export { ForwardRef as ReactComponent };